import './_quick-shop-product-options.scss';
import component from './quick-shop-product-options';

export default component;
